export default __webpack_public_path__ + "static/media/ellipse1.38472f6d.png";